import { useState } from "react";
import { toast } from "sonner";
import { FileLock2, FileText, Loader2 } from "lucide-react";
import { http, apiError } from "../../lib/api";

const OPTIONS = [
  ["internal", "Internal PDF", FileLock2, "Includes internal notes and staff comments. Do not share with customers."],
  ["external", "Shareable PDF", FileText, "Customer-facing communication only. Safe to send to the customer."],
];

export const ExportPdf = ({ item }) => {
  const [busy, setBusy] = useState("");
  const download = async (kind) => {
    setBusy(kind);
    try {
      const { data } = await http.get(`/admin/inquiries/${item.id}/export`, { params: { kind }, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `${item.ref || "inquiry"}-${kind === "internal" ? "internal" : "shareable"}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success(kind === "internal" ? "Internal PDF downloaded" : "Shareable PDF downloaded");
    } catch (e) {
      const blob = e?.response?.data;
      const detail = blob instanceof Blob ? await blob.text().then((t) => JSON.parse(t)?.detail).catch(() => null) : null;
      toast.error(typeof detail === "string" ? detail : apiError(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <section data-testid="export-pdf">
      <p className="eyebrow mb-3">Export timeline</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {OPTIONS.map(([kind, label, Icon, hint]) => (
          <button key={kind} onClick={() => download(kind)} disabled={!!busy} data-testid={`export-${kind}-pdf`}
            className="text-left border border-white/15 hover:border-[var(--gold)] p-4 transition-colors disabled:opacity-60">
            <span className="flex items-center gap-2 text-sm text-slate-100">{busy === kind ? <Loader2 className="w-4 h-4 animate-spin text-gold" /> : <Icon className="w-4 h-4 text-gold" />}{label}</span>
            <span className="block text-xs text-slate-400 mt-1.5">{hint}</span>
          </button>
        ))}
      </div>
    </section>
  );
};
